import { func } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import Association from '../../associations/Association';
import DiscardableForm from '../../generic/DiscardableForm';
import SingleSelect from '../../generic/SingleSelect';
import { isAccounting, isSBO, isSuperuser } from '../../layout/Variant/Variant';
import { businessModels, salesUnits } from '../../opportunities/constants';
import { zmsAMMerchantShape } from '../../prop-types';
import { merchantFrameworkOptions } from '../constants';

function MerchantForm({ model, onChange, onSubmit, onDiscard }) {
  const {
    merchantId,
    pcId,
    salesUnit,
    framework,
    pcSalesUnit,
    hasTransitionDiscount,
    eligibleForZMSAMPush,
    countries,
    invoiceBillingEntityId,
    sapId,
    businessModel,
  } = model;

  const inputProps = { onChange, readOnly: !onSubmit };

  return (
    <DiscardableForm onSubmit={onSubmit} onDiscard={onDiscard}>
      <Row>
        <Col>
          <FormGroup row>
            <Label sm={4} for="mc-merchantId">
              Merchant ID
            </Label>
            <Col sm={8}>
              <Input
                id="mc-merchantId"
                name="merchantId"
                value={merchantId}
                {...inputProps}
                readOnly
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-pcId">
              Partner Consultant
            </Label>
            <Col sm={8}>
              <Association
                id="mc-pcId"
                name="pcId"
                value={pcId}
                type="user"
                {...inputProps}
                showIcon
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-pcSalesUnit">
              Managed Service Sales Unit
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={salesUnits}
                id="mc-pcSalesUnit"
                name="pcSalesUnit"
                value={pcSalesUnit}
                {...inputProps}
                readOnly
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-selfServiceSalesUnit">
              Self Service Sales Unit
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={salesUnits}
                id="mc-selfServiceSalesUnit"
                name="selfServiceSalesUnit"
                value={salesUnit}
                {...inputProps}
                readOnly
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-framework">
              Merchant Framework
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={merchantFrameworkOptions}
                id="mc-framework"
                name="framework"
                value={framework}
                {...inputProps}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-hasTransitionDiscount">
              Transition Discount
            </Label>
            <Col sm={8}>
              <Input
                type="checkbox"
                id="mc-hasTransitionDiscount"
                name="hasTransitionDiscount"
                checked={hasTransitionDiscount}
                className="form-control form-checkbox"
                {...inputProps}
                disabled={!onSubmit}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-eligibleForZMSAMPush">
              Eligible for ZMSAM Push
            </Label>
            <Col sm={8}>
              <Input
                type="checkbox"
                id="mc-eligibleForZMSAMPush"
                name="eligibleForZMSAMPush"
                checked={eligibleForZMSAMPush}
                className="form-control form-checkbox"
                {...inputProps}
                disabled={!onSubmit}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-countries">
              Countries
            </Label>
            <Col sm={8}>
              <Input
                id="mc-countries"
                name="countries"
                value={countries}
                {...inputProps}
                readOnly
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-invoiceBillingEntityId">
              Billing Entity
            </Label>
            <Col sm={8}>
              <Association
                id="mc-invoiceBillingEntityId"
                name="invoiceBillingEntityId"
                value={invoiceBillingEntityId}
                type="zmsamMerchant"
                onChange={onChange}
                readOnly={
                  !onSubmit || (!isSBO() && !isAccounting() && !isSuperuser())
                }
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-sapId">
              SAP ID
            </Label>
            <Col sm={8}>
              <Input
                id="mc-sapId"
                name="sapId"
                value={sapId}
                {...inputProps}
                readOnly
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="mc-businessModel">
              Business Model
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={businessModels}
                id="mc-businessModel"
                name="businessModel"
                value={businessModel}
                {...inputProps}
                readOnly
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </DiscardableForm>
  );
}

MerchantForm.propTypes = {
  model: zmsAMMerchantShape.isRequired,
  onChange: func,
  onSubmit: func,
  onDiscard: func,
};

MerchantForm.defaultProps = {
  onChange: undefined,
  onSubmit: undefined,
  onDiscard: undefined,
};

export default MerchantForm;
